import React, { useEffect, useState } from "react";

const AnimationTitleHeader = () => {
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    const word = ["Portfolio"];

    const newLetters = word[0].split("").map((char, index) => (
      <span
        key={index}
        className="animation "
        style={{ animationDelay: `${index / 5}s` }}
      >
        {char}
      </span>
    ));

    setLetters(newLetters);
  }, []);

  return <p className="containerLetterBanner"> {letters}</p>;
};
export default AnimationTitleHeader;
